import React, { Fragment, FunctionComponent } from 'react';

const Nbsp: FunctionComponent = () => <Fragment>&nbsp;</Fragment>;

export default Nbsp;
